import { Box, Grid, Modal, Stack, Typography, useColorScheme } from "@mui/material";
import { MainInput, SuccessButton, MainCheckbox, MainSelect } from "../index";
import { Constants } from "../../utils/constants";
import { useEffect, useState } from "react";
import { isValidUrl } from "../../utils/stringFormat";

export default function ProjectEditModal({
    open,
    onClose,
    onFinish,
    project,
}) {
    const { mode } = useColorScheme();
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 360,
        maxWidth: 550,
        maxHeight: "90%",
        bgcolor: 'background.paper',
        border: `1px solid ${Constants.Colors[mode].border}`,
        borderRadius: "8px",
        boxShadow: 24,
        p: "1.5rem",
        overflowY: "auto",
    };
    const formDataValues = {
        email_report: false,
        utm_enabled: false,
        utm_medium: "",
        utm_source: "",
        block_urls: "",
        font_color: "",
        font_size: "",
        background_color: "",
        redirect_message: "",
    };
    const [sitemapError, setSitemapError] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [formData, setFormData] = useState({});

    useEffect(() => {
        setSitemapError(false);
        setDisabled(false);
        setFormData({
            ...formDataValues,
            ...project,
        });
    }, [open, project?.project_id, project]);
    const handleSubmit = (e) => {
        e.preventDefault();
        const data = new FormData(e.currentTarget);
        const sitemap = data.get("sitemap");
        var isValid = true;
        if (!isValidUrl(sitemap)) {
            setSitemapError(true);
            isValid = false;
        } else {
            setSitemapError(false);
        }
        if (!isValid) {
            return;
        }
        setDisabled(true);
        onFinish(formData);
    }
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-project-create-title"
            aria-describedby="modal-project-create-description"
        >
            <Box sx={style}>
                <Typography id="modal-project-create-title" variant="h6" component="h2" fontWeight={"bold"}>
                    Update project
                </Typography>
                <Box component={"form"} onSubmit={handleSubmit} noValidate mt={"1.5rem"}>
                    <Stack direction={"column"} spacing={"1.25rem"}>
                        <MainInput
                            key="sitemap"
                            name="sitemap" type="textarea"
                            placeholder={`Paste your Website XML Sitemap URL(s), e.g.\nhttps://yoursite.com/sitemap_collections.xml\nhttps://yoursite.com/sitemap_products.xml\nhttps://yoursite.com/sitemap_pages.xml`}
                            required
                            error={sitemapError}
                            helperText={sitemapError ? "Sitemap URL must be a valid XML sitemap URL" : ""}
                            value={formData?.sitemap_xml}
                            onChange={(e) => setFormData({ ...formData, sitemap_xml: e.target.value })}
                        />
                        <Stack direction={"row"} alignItems={"center"} spacing={"1.25rem"}>
                            <MainCheckbox type="success" label="UTM Enabled" checked={formData.utm_enabled} onChange={(e) => setFormData({ ...formData, utm_enabled: e.target.checked })} />
                            <MainCheckbox type="default" label="Send weekly project reports" checked={formData?.email_report} onChange={(e) => setFormData({ ...formData, email_report: e.target.checked })} />
                        </Stack>
                        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={2}>
                            <MainInput
                                key="utm_source"
                                name="utm_source" type="text"
                                placeholder="UTM Source"
                                disabled={!formData?.utm_enabled}
                                value={formData?.utm_source}
                                onChange={(e) => setFormData({ ...formData, utm_source: e.target.value })}
                            />
                            <MainInput
                                key="utm_medium"
                                name="utm_medium" type="text"
                                placeholder="UTM Medium"
                                disabled={!formData?.utm_enabled}
                                value={formData?.utm_medium}
                                onChange={(e) => setFormData({ ...formData, utm_medium: e.target.value })}
                            />
                        </Stack>
                        <MainInput
                            label="BlockList URLs"
                            name="block_urls"
                            type="textarea"
                            placeholder={`ex: https://test.com/blocked-url1\nhttps://test.com/blocked-url2`}
                            required
                            value={formData?.block_urls}
                            onChange={(e) => setFormData({ ...formData, block_urls: e.target.value })}
                        />
                        <Box>
                            <Typography variant="body2" sx={{ marginBottom: "0.25rem" }}>
                                Redirect Page Setting
                            </Typography>
                            <Grid
                                container
                                spacing={1}
                            >
                                <Grid item size={{ xs: 12, sm: 4, }}>
                                    <MainSelect
                                        label="Font Size"
                                        name="font_size"
                                        size="small"
                                        value={formData?.font_size}
                                        onChange={(e) => setFormData({ ...formData, font_size: e.target.value })}
                                        options={Constants.FontSizes}
                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 4, }}><MainInput
                                    type="color"
                                    label="Font Color"
                                    name="font_color"
                                    value={formData?.font_color}
                                    onChange={(e) => setFormData({ ...formData, font_color: e.target.value })}
                                /></Grid>
                                <Grid item size={{ xs: 12, sm: 4, }}>
                                    <MainInput
                                        type="color"
                                        label="Background Color"
                                        name="background_color"
                                        value={formData?.background_color}
                                        onChange={(e) => setFormData({ ...formData, background_color: e.target.value })}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                        <MainInput
                            label="Redirect Message"
                            name="redirect_message"
                            type="textarea"
                            placeholder={`Enter redirect customization message`}
                            required
                            value={formData?.redirect_message}
                            onChange={(e) => setFormData({ ...formData, redirect_message: e.target.value })}
                            helperText="'Powered by redirectmapper.com' is added automatically."
                        />

                        <Stack direction={"row"} justifyContent={"flex-end"}>
                            <SuccessButton type="submit" text="Update" size="medium" fullWidth={false} disabled={disabled} isSubmitting={disabled} />
                        </Stack>
                    </Stack>
                </Box>
            </Box>
        </Modal>
    );
}